// extracted by css-extract-rspack-plugin
export default {"root":"wcZ33v","dot":"aVJF2H","current":"oEY4iB"};